import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineMessageButtonComponent } from './inline-message-button.component';
import { ButtonModule, IconModule } from '@liberty-financial/ng-components';

@NgModule({
  declarations: [InlineMessageButtonComponent],
  imports: [CommonModule, IconModule, ButtonModule],
  exports: [InlineMessageButtonComponent]
})
export class InlineMessageButtonModule { }
